import React from 'react';
import HeatmapCanvas from './HeatmapCanvas';
import '../../../../css/_analytics_viz.css';

function orientationLabel(heatmap) {
  if (heatmap.orientation === 'site') return `Site: ${heatmap.siteName || 'Unknown'}`;
  return heatmap.orientation === 'left' ? 'Left orientation' : 'Right orientation';
}

/**
 * Grid of artefact density heatmaps. The `heatmap` workflow node stores one
 * entry per group: { orientation, siteName, graveCount, artefacts, graves }.
 */
export default function HeatmapViz({ heatmaps }) {
  const withArtefacts = (heatmaps || []).filter((h) => (h.artefacts || []).length > 0);

  if (withArtefacts.length === 0) {
    return (
      <div className="analysis-empty">
        <span className="material-symbols-rounded analysis-empty-icon">visibility_off</span>
        <span>No graves with artefacts, scale data and contours found.</span>
      </div>
    );
  }

  return (
    <div className="heatmap-grid">
      {withArtefacts.map((heatmap, index) => (
        <div key={`${heatmap.orientation}-${heatmap.siteName || index}`} className="heatmap-card">
          <div className="heatmap-title">{orientationLabel(heatmap)}</div>
          <HeatmapCanvas
            artefacts={heatmap.artefacts}
            graves={heatmap.graves}
            orientation={heatmap.orientation === 'site' ? null : heatmap.orientation}
          />
          <p className="heatmap-caption">
            {heatmap.graveCount} graves — artefact density with grave outlines
          </p>
        </div>
      ))}
    </div>
  );
}
